import { render, staticRenderFns } from "./AppDropdownItem.vue?vue&type=template&id=34d2d74e&"
import script from "./AppDropdownItem.vue?vue&type=script&lang=js&"
export * from "./AppDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./AppDropdownItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports